import {GET_COMPANIES_ERROR, GET_COMPANIES_REQUEST, GET_COMPANIES_SUCCESS} from "../constants/companies";
import {ICompany} from "../../models/Company";
import {IActionCompanies} from "../actions/companies";


export interface ICompaniesState {
    loading: boolean
    error: string
    data: ICompany[]
    total: number
    by: number
}

const initialState: ICompaniesState = {
    data: [],
    loading: false,
    error: '',
    total: 0,
    by: 0
};

export default function companies(state = initialState, action: IActionCompanies): ICompaniesState {
    switch (action.type) {
        case GET_COMPANIES_REQUEST:
            return {
                data: [],
                loading: true,
                error: '',
                total: 0,
                by: 0
            };
        case GET_COMPANIES_SUCCESS:
            const {data, total, by} = action.payload;
            return {
                data,
                loading: false,
                error: '',
                total,
                by
            };
        case GET_COMPANIES_ERROR:
            return {
                data: [],
                loading: false,
                error: action.payload,
                total: 0,
                by: 0
            };
        default:
            return state;
    }
}
